import React from 'react'
import { GetRoadHome } from '../components/newHome/GetRoadHome'
import drivingInstructor from "../assets/images/driving-instructor.png";
import { Contact } from '../components/contactus/Contact';
import EmbarkBanner from '../components/newpages/embark/EmbarkBanner';
import { GuideTestimonials } from '../components/newpages/guide/GuideTestimonials';
const BecomeInstructor = () => {
  return (
    <>
    <EmbarkBanner
        heading="Become a Driving Instructor"
        button="Contact Us Now"
        dynamicImage={drivingInstructor}
      />
      <Contact/>
      <GuideTestimonials textWhite="text-white"/>
    </>
  )
}

export default BecomeInstructor